import { useSelector } from 'react-redux';
import { EPriceDisplayMode, IHotelFilter, EBookingMode } from '../types';

export const filterSelector = () => {
  return useSelector<any, IHotelFilter | null>(state => {
    return state.filter.value || null;
  });
};

export const priceDisplayModeSelector = () => {
  return useSelector<any, EPriceDisplayMode | null>(state => {
    return state.filter.priceDisplayMode || null;
  });
};

export const bookingModeSelector = () => {
  return useSelector<any, EBookingMode | null>(state => {
    return state.filter.bookingMode || null;
  });
};

export const combinedBookingViewSelector = () => {
  return useSelector<any, boolean>(state => {
    return state.filter.combinedBookingView || false;
  });
};
